// Copyright (c) Docugami, Inc. All rights reserved.

export enum BuildType {
    None = 'None',
    Baseline = 'Baseline',
    Ingestion = 'Ingestion',
    Tag = 'Tag',
    Clustering = 'Clustering',
    RealTimeUserFeedback = 'RealTimeUserFeedback',
    RealTimeUserFeedbackTag = 'RealTimeUserFeedbackTag',
    StreamingDgml = 'StreamingDgml'
}
